module.exports = __webpack_public_path__ + "components/modal-app-popup/static/opera-icon-6dd569e9ab1f376f38b1b9d9883df613.webp";